import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OrderCustomAnswersSlice } from './custom-answers-types'

const INITIAL_STATE: OrderCustomAnswersSlice = {}

const orderCustomAnswersSlice = createSlice({
  name: 'customAnswers',
  initialState: INITIAL_STATE,
  reducers: {
    setValue: (state, action: PayloadAction<OrderCustomAnswersSlice>) => {
      return { ...state, ...action.payload }
    },
  },
})

export default orderCustomAnswersSlice
